module.exports = __webpack_public_path__ + "image/jicai_docs_2.23fcf5a.png";